import React, { useEffect, useState } from 'react'
import { TreeSelect, Divider, Input, Button } from '@arco-design/web-react'
import { IconWastePaper, IconSearch } from '@arco-iconbox/react-aidb-v2'
import {
  getBookLibraryClassificationBook,
  getNewsLibraryContentSourceStation,
} from './utils/api'
import Empty from './Empty'
import { v4 as uuidv4 } from 'uuid'

import styles from './style/search-history-mod.module.less'

interface Props {
  disabled: boolean
  category: 'BOOK_CLASSIFICATION' | 'CONTENT_STATION_VALUE'
  value: string
  setValue: (string: string) => void
  idValue: string
  setIdValue: (string: string) => void
}

function TreeSelectMod(props: Props) {
  const { disabled, category, value, setValue, setIdValue, idValue } = props

  // 刷新状态
  const [state, setState] = useState<boolean>(false)
  // 判断是否接口出错需要刷新获取
  const [isError, setIsError] = useState<boolean>(false)
  // 所有数据
  const [date, setDate] = useState<object[]>([])

  useEffect(() => {
    // 发送请求
    sendRequest()
  }, [])

  // useEffect(() => {
  //   // 使用 setTimeout 确保 DOM 已经更新
  //   setTimeout(() => {
  //     // 查找所有已展开的树节点
  //     const nodes = document.querySelectorAll('.arco-tree-node-expanded')

  //     nodes.forEach((node) => {
  //       // 设置 'aria-expanded' 属性为 'false'
  //       node.setAttribute('aria-expanded', 'false')
  //     })
  //   }, 1000)
  // }, [date])

  // 发送请求
  const sendRequest = () => {
    // 获取书籍分类
    if (category === 'BOOK_CLASSIFICATION') {
      getClassificationBookBack()
    } else if (category === 'CONTENT_STATION_VALUE') {
      getNewsLibraryContentSourceStationBack()
    }
  }

  // 获取书籍分类
  const getClassificationBookBack = () => {
    setState(true)
    getBookLibraryClassificationBook()
      .then((res) => {
        if (res.status == 200) {
          let data = convertData(res.data)
          setDate(data)
          setState(false)
          setIsError(false)
        } else {
          setDate([])
          setState(false)
          setIsError(true)
        }
      })
      .catch((err) => {
        setState(false)
        setIsError(true)
      })
  }

  // 获取新闻库内容源站
  const getNewsLibraryContentSourceStationBack = () => {
    setState(true)
    getNewsLibraryContentSourceStation()
      .then((res) => {
        console.log(res)

        if (res.status == 200) {
          let data = convertData(res.data)
          setDate(data)
          setState(false)
          setIsError(false)
        } else {
          setDate([])
          setState(false)
          setIsError(true)
        }
      })
      .catch((err) => {
        setState(false)
        setIsError(true)
      })
  }

  //  整理数据
  const convertData = (
    data: Array<{ id: string; name: string; children?: Array<any> }>,
  ) => {
    return data.map((item, index) => {
      let newArr = {
        title: item.name,
        value: item.name,
        // key: item.id + '_' + uuidv4(),
        key: item.id,
      }
      if (item.children) newArr['children'] = convertData(item.children)
      return newArr
    })
  }

  return (
    <div className={'search-tree-select'}>
      <TreeSelect
        showSearch // 可搜索模式
        allowClear
        disabled={disabled}
        unmountOnExit={false} // 是否在隐藏的时候销毁 DOM 结构
        treeData={date}
        value={idValue}
        treeProps={{
          autoExpandParent: false, // 默认关闭节点
        }}
        onChange={(value: string, extra: any) => {
          // console.log(value, extra)
          if (!extra.trigger) return
          setValue(extra.trigger.title)
          setIdValue(value)
        }}
        onClear={() => {
          setValue('')
          setIdValue('')
        }}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode as Element
        }}
        notFoundContent={
          isError ? (
            <Empty onClick={() => sendRequest()} state={state} />
          ) : (
            <Empty title="暂无数据！" state={state} />
          )
        }
        // style={{ width: '100%' }}
        // dropdownMenuStyle={{ maxHeight: 300 }}
      />
    </div>
  )
}

export default TreeSelectMod
